import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import DataTable from "react-data-table-component";
import { PropagateLoader } from "react-spinners";
import { FaArrowRight } from "react-icons/fa";
import NoData from "../../atoms/NoData";
import Button from "../../atoms/Button";
import { getRegimen } from "../../../data/regimenFiscalData";
import { getConditionalRowStyles } from "../../../styles/expandedStyles";

const DFEmpresaList = ({ data, loading }) => {
    const navigate = useNavigate();
    const [expandedRow, setExpandedRow] = useState(null);

    const handlePush = (id) => {
        navigate(`/clientes/empresas/${id}/defensa_fiscal`);
    };

    const columns = [
        { name: "Empresa", cell: row => (
            <div className="flex flex-col my-1">
                <p className="text-blue-700 bg-blue-100 p-1 rounded-lg w-fit font-semibold"> {row.name}  </p>
                <p> {row?.name_rl ? `RL: ${row.name_rl}` : null} </p>
            </div>
            ), 
        },
        { name: "Información", cell: row => (
            <div className="flex flex-col">
                <p> Regimen: {row.type === "LegalEntitie" ? "PERSONA MORAL" : "PERSONA FISICA"} </p>
                <p>{row.rfc}</p>
            </div>
            ),
        },
        { name: "Acciones", cell: row => (
            <div className="flex flex-row space-x-4">
                <Button text={<FaArrowRight size={22} />} bgColor="orange" width="w-10" onClick={()=> handlePush(row.id)} />
            </div>
            ),
            width: "100px"
        },
    ];

    const columnsResponsive = [
        { name: "Información", cell: row => (
            <div className="flex flex-col">
                <p> {row.name}  </p>
                <p>{row.rfc}</p>
                <p> {row?.name_rl ? `RL ${row.name_rl}` : null} </p>
                <p> Regimen: {row.type === "LegalEntitie" ? "PERSONA MORAL" : "PERSONA FISICA"} </p>
                <p>Regimen fiscal: {getRegimen(row.c_RegimenFiscal)}</p>
            </div>
            ),
        },
    ];

    const ExpandedComponent = ({ data }) => (
        <div className="p-2 w-full flex flex-row justify-around">
            <Button text={<FaArrowRight size={22} />} bgColor="orange" width="w-10" onClick={()=> handlePush(data.id)} />
        </div>
    );

    const conditionalRowStyles = getConditionalRowStyles(expandedRow);

    return(
        <div>
            <div className="block md:hidden">
                <DataTable
                    data={data}
                    progressPending={loading}
                    columns={columnsResponsive}
                    progressComponent={
                        <div className="w-full h-20 flex justify-center items-center">
                            <PropagateLoader color="red" />
                        </div>
                    }
                    noDataComponent={<NoData/>}
                    pagination
                    responsive
                    expandableRows
                    expandableRowsComponent={ExpandedComponent}
                    expandableRowExpanded={(row) => row?.id === expandedRow?.id}
                    onRowExpandToggled={(expanded, row) => {
                        setExpandedRow(expanded ? row : null);
                    }}
                    conditionalRowStyles={conditionalRowStyles}
                />
            </div>
            <div className="hidden md:block">
                <DataTable
                    data={data}
                    progressPending={loading}
                    columns={columns}
                    progressComponent={
                        <div className="w-full h-20 flex justify-center items-center">
                            <PropagateLoader color="red" />
                        </div>
                    }
                    noDataComponent={<NoData/>}
                    pagination
                />
            </div>
        </div>
    );
};

export default DFEmpresaList;